// Import model
import { FilterProjectTaskRequest } from '../models/FilterProjectTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProjectTaskCondition } from '../models/ProjectTaskCondition';
import { ProjectTaskFields } from '../models/ProjectTaskFields';
import { ProjectTaskIndexedFields } from '../models/ProjectTaskIndexedFields';

// Import dependency serializers (for complex types)
import { ProjectTaskConditionSerializer } from './ProjectTaskConditionSerializer';
import { ProjectTaskFieldsSerializer } from './ProjectTaskFieldsSerializer';
import { ProjectTaskIndexedFieldsSerializer } from './ProjectTaskIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProjectTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProjectTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProjectTaskRequest instance
   */
  static deserialize(json: string): FilterProjectTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProjectTaskRequest instance
   */
  static fromObject(obj: any): FilterProjectTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProjectTaskRequest');
    }


    const instance: FilterProjectTaskRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProjectTaskIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProjectTaskFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProjectTaskConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProjectTaskRequest instances
   */
  static deserializeArray(json: string): FilterProjectTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProjectTaskRequest instance to a JSON string
   */
  static serialize(instance: FilterProjectTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProjectTaskRequest instance to a plain object
   */
  static toObject(instance: FilterProjectTaskRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProjectTaskConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProjectTaskRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProjectTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
